<template>
  <p
    key="former-alert"
    :class="classes"
  >
    <slot>
      <b>Oops!</b>

      Algo deu errado. Por favor, verifique os campos preenchidos e tente novamente.
    </slot>
  </p>
</template>

<script>
  export default {
    name: 'FormerAlert',
    props: {
      left: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'error',
      },
    },
    computed: {
      classes() {
        const {
          type,
        } = this;

        const classes = [`former-alert former-alert-${type}`];

        if (this.left) {
          classes.push(`former-alert-${type}-left`);
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-alert {
    padding: $gutter;
    text-align: center;

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter $gutter-big;
    }
  }

  .former-alert-error {
    background-color: $red;
    color: $white;
  }

  .former-alert-success {
    background-color: $green;
    color: $white;
  }

  .former-alert-warning {
    background-color: $yellow;
    color: $white;
  }

  .former-alert-left {
    text-align: left;
  }
</style>
